import styled from "styled-components";
import Button, { BUTTON_SIZES } from "../../../elements/v2/Button/Button";

export const ActionButton = styled(Button).attrs({
  size: BUTTON_SIZES.MEDIUM,
})`
  width: 100%;
`;
